export default {
  namespaced: true,
  tenants: {
    title: "tenant | tenants",
    title_plural: "Tenants",
    number_of_routers: "Número de Routers",
    _name: "Nome",
    main_image: "imagem principal",
    logo_image: "imagem do logotipo",
    image_mobile_app: "Imagem do aplicativo móvel",
    all: "todos os tenants",
    store:{
      tenant_storage: "Tenant Armazenar",
      storage: "Armazenar",
      storage_service: "Serviço de armazenamento",
      assigned_space: "Espaço Atribuído",
      assigned_space_gb: "Espaço Atribuído gb",
      assigned_space_mb: "Espaço Atribuído mb",
      used_space: "Espaço Usado",
      used_space_gb: "Espaço Usado gb",
      used_space_mb: "Espaço Usado mb",
      type: "Type",
      files: "Arquivos",
      assigned_space_min: "Espaço mínimo alocado",
      assigned_space_max: "Espaço máximo alocado",
      used_space_min: "Espaço mínimo utilizado",
      used_space_max: "Espaço máximo utilizado",
    },
    file:{
      image: "Imagem",
      id: "Id",
      name: "Nome",
      extension: "Extensão",
      size: "Tamanho",
      storage_type: "Tipo de armazenamento",
      directory: "Diretório",
      last_access: "Último acesso",
      size_min: "Tamanho mínimo",
      size_max: "Tamanho máximo",
      created_from: "Criado a partir de",
      created_to: "Criado até",
      file_explorer: "Explorador de Arquivos",
      subdirectories_and_direct_files: "Subdiretórios e arquivos diretos",
      direct_files: "Arquivos diretos",
      files_in_subdirectory: "Arquivos no subdiretório"
    },
    message:{
      add: "Locatário adicionado com sucesso",
      edit: "Locatário editado corretamente",
      delete: "Corretor removido do inquilino",
      error: "Ocorreu um erro",
    }
  },
};
